(function ($) {
	'use strict';

	$(document).ready(function () {
		if (typeof $.fn.validate !== 'function') {
			return;
		}

		var messages = {
			log: {
				required: 'Please enter your username or email'
			},
			pwd: {
				required: 'Please enter your password'
			}
		};

		if (typeof localized_frontend_data !== 'undefined') {
			messages.log.required = localized_frontend_data.txt_log_name_validation || messages.log.required;
			messages.pwd.required = localized_frontend_data.txt_log_pwd_validation || messages.pwd.required;
		}

		$('.wp-user-form').each(function () {
			var form = $(this);

			if (form.data('validator')) {
				return;
			}

			form.validate({
				rules: {
					log: {
						required: true
					},
					pwd: {
						required: true
					}
				},
				messages: messages,
				onkeyup: false
			});

			form.on('input', 'input[name="log"], input[name="pwd"]', function () {
				var validator = form.data('validator');
				var element = this;

				if (!validator) {
					return;
				}

				var errors = validator.errorsFor(element);

				validator.hideThese(errors);
				errors.remove();

				$(element)
					.removeClass(validator.settings.errorClass)
					.removeAttr('aria-describedby')
					.attr('aria-invalid', 'false');

				delete validator.invalid[element.name];

				validator.errorList = $.grep(validator.errorList, function (error) {
					return error.element !== element;
				});
			});
		});
	});
})(jQuery);
